<template>
  <div class="container" :class="{noMarginTop: type === 'extras' && bKey === 0}" :style="{height: type === 'extras' ? 'auto' : '176px'}" @mouseenter="showFixed" @mouseleave="hiddenFixed">
    <!-- extras-其他模块 -->
    <template v-if="type === 'extras'">
      <div class="library-item-select" v-if="!isEdit"></div>
      <div class="library-item-content">
        <div class="item-desc" v-html="itemData.description"
             v-if="itemData.description"></div>
        <div class="operation-container flex">
          <div class="operation-date">
            更新时间：{{timeFormatFilter(itemData.updated_at)}}
          </div>
          <div class="operation-btn" :class="{'operation-btn-disabled': itemData.isSelect}" @click="debounce(() => selectExperience(itemData, index, bKey), 500)">
            {{ itemData.isSelect ? '已使用' : '使用经历' }}
          </div>
        </div>
<!--        <div class="item-date" v-if="itemData.updated_at">更新时间：{{timeFormatFilter(itemData.updated_at)}}</div>-->
      </div>
<!--      <div class="library-item-delete library-item-delete-icon" @click.stop="debounce(() => deleteExperience(itemData, index, bKey,), 500)">-->
<!--        <i class="iconfont icontrash-" />-->
<!--      </div>-->
    </template>
    <!-- 除去其他模块 -->
    <template v-else>
      <template v-if="type !== 'personal_summary' && type !== 'skill_list'">
        <div class="library-item-content">
          <div style="width: 100%;height: calc(100% - 114px);">
            <div class="item-name text-overflow" v-if="itemData.company || itemData.university || itemData.name">
              {{itemData.company || itemData.university || itemData.name}}
            </div>
            <div class="item-info text-overflow"
                 v-if="type === 'edus' && (itemData.city || itemData.major || itemData.degree || itemData.uni_school)">
              <span v-if="itemData.city">{{itemData.city}}</span>
              <span v-if="itemData.major">{{itemData.major}}</span>
              <span v-if="itemData.degree">{{itemData.degree}}</span>
              <span v-if="itemData.uni_school">{{itemData.uni_school}}</span>
            </div>
            <div class="item-info text-overflow" v-else-if="itemData.city || itemData.title || itemData.dept">
              <span v-if="itemData.city">{{itemData.city}}</span>
              <span v-if="itemData.title">{{itemData.title}}</span>
              <span v-if="itemData.dept">{{itemData.dept}}</span>
            </div>
            <div class="item-desc" v-if="itemData.description" v-html="itemData.description"></div>
          </div>
          <div class="operation-container flex">
            <div class="operation-date">
              更新时间：{{timeFormatFilter(itemData.updated_at)}}
            </div>
            <div class="operation-btn" :class="{'operation-btn-disabled': itemData.isSelect}" @click="debounce(() => selectExperience(itemData, index), 500)">
              {{ itemData.isSelect ? '已使用' : '使用经历' }}
            </div>
          </div>
        </div>
<!--        <div class="library-item-delete library-item-delete-icon" @click.stop="deleteExperience(itemData, index)">-->
<!--          <i class="iconfont icontrash-" />-->
<!--        </div>-->
      </template>
      <!-- 个人总结 -->
      <template v-else>
        <div class="library-item-content">
          <div style="width: 100%;height: calc(100% - 67px)">
            <div class="item-desc" style="margin-top: 0" v-if="itemData.description" v-html="itemData.description"></div>
          </div>
          <div class="operation-container flex" style="height: 47px">
            <div class="operation-date">
              更新时间：{{timeFormatFilter(itemData.updated_at)}}
            </div>
            <div class="operation-btn" :class="{'operation-btn-disabled': itemData.isSelect}" @click="debounce(() => selectExperience(itemData, index), 500)">
              {{ itemData.isSelect ? '已使用' : '使用经历' }}
            </div>
          </div>
        </div>
<!--        <div class="library-item-delete library-item-delete-icon" @click.stop="deleteExperience(itemData, index)">-->
<!--          <i class="iconfont icontrash-" />-->
<!--        </div>-->
      </template>
    </template>
  </div>
</template>

<script>
import { timeFormatFilter } from '@/assets/js/util'
import { componentsMixin } from '@/assets/js/mixins/components'
import moment from 'moment'
import { mapState, mapMutations } from 'vuex'
export default {
  name: "ExperienceCard",
  mixins: [componentsMixin],
  props: {
    itemData: {
      type: [Object, Array],
    },
    type: {
      type: [String, Number],
    },
    currentInfo: {
      type: Object
    },
    otherTitle: {
      type: Object
    },
    bKey: {
      type: [String, Number]
    },
    isEdit: {
      type: Boolean
    },
    index: {
      type: Number
    },
    experienceIndex: {
      type: Number
    }
  },
  computed: {
    ...mapState('editor', [ 'jobTabCardDialogTimer', 'jobTabCardContentScrollY', 'showJobTabCardDialog', 'showJobTabCardDialogSelf', 'showJobTabCardDialogData' ])
  },
  methods: {
    ...mapMutations('editor', ['setJobTabCardDialogTimer', 'setJobTabCardDialogTop', 'setShowJobTabCardDialog', 'setShowJobTabCardDialogSelf', 'setShowJobTabCardDialogData']),
    moment,
    timeFormatFilter,
    getOtherTitle (type) {
      let key = type.substring(0, type.length - 1)
      // this.cvDetail.submodule_info[key + '_title'] ||
      return this.otherTitle[key]
    },
    // 删除经历
    deleteExperience(data, index, bKey) {
      this.$emit('deleteExperience', data, index, bKey, this.type, this.experienceIndex)
    },
    // 选中经历
    selectExperience(data, index, bKey) {
      this.$emit('selectExperience', data, index, bKey, this.type, this.experienceIndex)
    },
    // 显示浮窗
    showFixed (e) {
      let { top } = e.target.getBoundingClientRect()
      clearTimeout(this.jobTabCardDialogTimer)
      // // 拿到最外侧父集的高度
      let fatherDomHeight = document.getElementById('libraryWrapper').clientHeight
      // // 职位卡片浮窗的 height 值
      let fixedDomHeight = 360
      let fixedDomTop = 0
      // 下边界检测
      if (top + 360 > fatherDomHeight + 72) {
        fixedDomTop = fatherDomHeight - fixedDomHeight
      } else {
        fixedDomTop = top - 72
      }

      this.setJobTabCardDialogTop(fixedDomTop)
      this.setShowJobTabCardDialogData({data: this.itemData, type: this.type, index: this.index, bKey: this.bKey, experienceIndex: this.experienceIndex})
      this.setShowJobTabCardDialog(true)
    },
    // 隐藏浮窗
    hiddenFixed () {
      let timer = setTimeout(() => {
        clearTimeout(this.jobTabCardDialogTimer)
        this.setShowJobTabCardDialog(false)
      }, 150)
      this.setJobTabCardDialogTimer(timer)
    },
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  padding: 20px 16px 0;
  position: relative;
  background: #F5F6FA;
  border-radius: 8px;
  //overflow: hidden;
  box-sizing: border-box;
  margin-top: 12px;
  color: #505667;
  &:first-child {
    margin-top: 0;
  }
  &:hover {
    .library-item-delete {
      display: block;
    }
  }
  &.disabled{
    opacity: 0.6;
  }
  .library-item-content {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .item-name {
      font-size: 16px;
      color: #505667;
      font-weight: 600;
      word-wrap:break-word;
    }
    .item-info {
      display: flex;
      word-wrap:break-word;
      margin-top: 14px;
      span {
        display: flex;
        &::after {
          content: "|";
          display: block;
          width: 10px;
          font-size: 12px;
          text-align: center;
        }
        &:last-child::after {
          content: "";
          width: 0;
        }
      }
    }
    .item-desc {
      width: 100%;
      max-height: 100%;
      line-height: 22px;
      word-wrap:break-word;
      margin-top: 8px;
      display: -webkit-box;
      overflow: hidden;
      -webkit-line-clamp: 4;
      -moz-line-clamp: 4;
      -webkit-box-orient: vertical;
    }
    .operation-container {
      width: 100%;
      height: 47px;
      margin-top: 20px;
      border-top: 1px dashed rgba($color:#AEB2BD , $alpha: 0.2);
      align-items: center;
      justify-content: space-between;
      .operation-date {
        font-size: 12px;
        color: #AEB2BD;
        &:hover{
          //background: rgba(103, 156, 255, 1);
          //color: #fff;
        }
      }
      &:hover{
        //background: #4183FF;
      }
      .operation-btn {
        @apply flex items-center justify-center;
        height: 26px;
        border-radius: 13px;
        padding: 6px 12px;
        color: #fff;
        background-color: #679CFF;
        cursor: pointer;
        &:hover{
          background: #4183FF;
        }
        &-disabled {
          opacity: 0.4;
          //cursor: not-allowed;
        }
      }
    }
    .library-item-delete {
      display: none;
      font-size: 14px;
      color: #AEB2BD;
      position: absolute;
      top: 22px;
      right: 20px;
      cursor: pointer;
      .tooltip {
        width: 100px;
        display: flex;
        position: absolute;
        top: -20px;
        left: 0;
        color: green;
        font-size: 12px;
      }
      i {
        font-weight: 600;
      }
      &:hover{
        color: #505667;
      }
    }
    .item-date {
      position: absolute;
      right: 24px;
      bottom: 14px;
      text-align: right;
      font-size: 12px;
      color: #AEB2BD;
    }
  }
}
.noMarginTop {
  margin-top: 0;
}
</style>
